import { render } from "./ChaseTravelFixed.vue?vue&type=template&id=221b4b9a&scoped=true"
import script from "./ChaseTravelFixed.vue?vue&type=script&lang=js"
export * from "./ChaseTravelFixed.vue?vue&type=script&lang=js"

import "./ChaseTravelFixed.vue?vue&type=style&index=0&id=221b4b9a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221b4b9a"]])

export default __exports__